module.exports = __webpack_public_path__ + "static/media/reason.dff7fa15.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/reason.png
// module id = 62
// module chunks = 0